import React from "react"
import FormFinancierBatch from "./Form"

export default function CreateFinancierBatch() {
  return <FormFinancierBatch />
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Batches/Create.js